import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

export const useTrialDashboardDesktopTypographyStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontFamily: 'Euclid',
    fontSize: 'clamp(1.1rem, 3vw, 2.75rem)',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'clamp(1.3rem, 3.2vw, 2.69rem)',
    letterSpacing: 'clamp(-0.022rem, -0.055vw, -0.055rem)',
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',

    [theme.breakpoints.down('md')]: {
      fontSize: 'clamp(1rem, 3vw, 2.2rem)',
      lineHeight: 'clamp(1.2rem, 3.2vw, 2.15rem)',
      letterSpacing: 'clamp(-0.02rem, -0.044vw, -0.044rem)'
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: '2.2rem',
      lineHeight: '2.15rem',
      letterSpacing: '-0.044rem',
      maxWidth: '100%',
      width: '100%'
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: '2.2rem',
      lineHeight: '2.15rem',
      letterSpacing: '-0.044rem',
      maxWidth: '100%',
      width: '100%'
    },

    '@media (min-width: 1850px)': {
      fontSize: '2.75rem',
      lineHeight: '2.69rem',
      letterSpacing: '-0.055rem',
      maxWidth: '100%',
      width: '100%'
    }
  },
  headingFirstLine: {
    fontFamily: 'Euclid',
    whiteSpace: 'normal',
    display: 'block',

    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('md', 'lg')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('lg', 'xl')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.up('xl')]: {
      whiteSpace: 'normal'
    },

    '@media (min-width: 1850px)': {
      whiteSpace: 'nowrap'
    }
  },
  headingSecondLine: {
    fontFamily: 'Euclid',
    whiteSpace: 'normal',
    display: 'block',

    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('md', 'lg')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('lg', 'xl')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.up('xl')]: {
      whiteSpace: 'normal'
    },

    '@media (min-width: 1850px)': {
      whiteSpace: 'nowrap'
    }
  },
  headingHighlight: {
    color: theme.palette.primary.main
  },
  description: {
    fontFamily: 'Euclid',
    fontSize: '24.63px',
    fontWeight: 600,
    lineHeight: '30px',
    letterSpacing: 0,
    color: '#394860',
    marginBottom: theme.spacing(4),
    maxWidth: '100%',
    width: '100%',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      lineHeight: '26px',
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('md', 'lg')]: {
      whiteSpace: 'normal'
    },

    [theme.breakpoints.between('lg', 'xl')]: {
      fontSize: '18px',
      lineHeight: '24px',
      whiteSpace: 'normal',
      maxWidth: '100%',
      width: '100%'
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: '18px',
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      width: '100%'
    },

    '@media (min-width: 1850px)': {
      fontSize: '24.63px',
      lineHeight: '30px',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      width: '100%'
    }
  },
  button: {
    fontFamily: 'Euclid',
    padding: theme.spacing(1.5, 4),
    fontSize: '1rem',
    textTransform: 'none',
    borderRadius: theme.shape.borderRadius,
    alignSelf: 'flex-start',
    marginBottom: '50px'
  }
}))
